/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountDeletionTask } from './';
import {
    AccountDeletionTaskFromJSON,
    AccountDeletionTaskFromJSONTyped,
    AccountDeletionTaskToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountDeletionTasks
 */
export interface AccountDeletionTasks {
    /**
     * The current page
     * @type {number}
     * @memberof AccountDeletionTasks
     */
    currentPage: number;
    /**
     * The size of a page
     * @type {number}
     * @memberof AccountDeletionTasks
     */
    pageSize: number;
    /**
     * The total number of pages matching the filters
     * @type {number}
     * @memberof AccountDeletionTasks
     */
    totalPages: number;
    /**
     * The total number of tasks matching the filters
     * @type {number}
     * @memberof AccountDeletionTasks
     */
    totalTasks: number;
    /**
     * The ID of the first returned task (depending on the order), if any, to use as a marker when fetching the previous page. Provided for convenience.
     * 
     * @type {string}
     * @memberof AccountDeletionTasks
     */
    firstTaskId?: string;
    /**
     * The ID of the last returned task (depending on the order), if any, to use as a marker when fetching the next page. Provided for convenience.
     * 
     * @type {string}
     * @memberof AccountDeletionTasks
     */
    lastTaskId?: string;
    /**
     * 
     * @type {Array<AccountDeletionTask>}
     * @memberof AccountDeletionTasks
     */
    tasks: Array<AccountDeletionTask>;
}

/**
 * Check if a given object implements the AccountDeletionTasks interface.
 */
export function instanceOfAccountDeletionTasks(value: object): value is AccountDeletionTasks {
    if (!('currentPage' in value) || value['currentPage'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('totalTasks' in value) || value['totalTasks'] === undefined) return false;
    if (!('tasks' in value) || value['tasks'] === undefined) return false;
    return true;
}

export function AccountDeletionTasksFromJSON(json: any): AccountDeletionTasks {
    return AccountDeletionTasksFromJSONTyped(json, false);
}

export function AccountDeletionTasksFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTasks {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'],
        'pageSize': json['pageSize'],
        'totalPages': json['totalPages'],
        'totalTasks': json['totalTasks'],
        'firstTaskId': json['firstTaskId'] == null ? undefined : json['firstTaskId'],
        'lastTaskId': json['lastTaskId'] == null ? undefined : json['lastTaskId'],
        'tasks': ((json['tasks'] as Array<any>).map(AccountDeletionTaskFromJSON)),
    };
}

export function AccountDeletionTasksToJSON(value?: AccountDeletionTasks | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'totalPages': value['totalPages'],
        'totalTasks': value['totalTasks'],
        'firstTaskId': value['firstTaskId'],
        'lastTaskId': value['lastTaskId'],
        'tasks': ((value['tasks'] as Array<any>).map((v) => AccountDeletionTaskToJSON(v))),
    };
}

